import { combineReducers } from 'redux';

import drawerMenuMobile from './drawerMenuMobile';

const reducer = combineReducers({
  [drawerMenuMobile.name]: drawerMenuMobile.reducer,
});

export default reducer;
